import { useEffect, useState } from 'react';
import { isEpTradingWindowOpen } from '@uo/shared';

/** Beijing 9:00–11:00 and 13:30–15:30. Re-checks every 15s. */
export function useEpTradingWindow(): boolean {
  const [open, setOpen] = useState(() => isEpTradingWindowOpen());
  useEffect(() => {
    const tick = () => setOpen(isEpTradingWindowOpen());
    tick();
    const id = window.setInterval(tick, 15_000);
    return () => window.clearInterval(id);
  }, []);
  return open;
}
